<!--
 * @Description:
 * @Author: LXG
 * @Date: 2022-01-27
 * @Editors: LXG
 * @LastEditTime: 2022-01-28
-->
<template>
  <div>
    <div class="background">
      <div class="header">
        <div class="header-wrap">
          <img
            src="@/assets/images/mobile/return.png"
            class="header-img"
            @click="goBack"
          />
        </div>
      </div>
      <img class="img1" src="../../assets/images/mobile/newbj.png" />
      <div class="login-content">
        <div class="login-right">
          <div
            class="form-content"
            ref="loginContainer"
            :class="{ newheight: type == 3 }"
          >
            <el-form
              ref="formData"
              :model="formData"
              :rules="loginRules"
              autocomplete="on"
              label-position="left"
              v-if="type == 0 || type == 1 || type == 5"
            >
              <h2 class="form-title">{{ this.headerTitle[this.type] }}</h2>
              <div class="input-login">
                <el-form-item
                  label="联系人"
                  label-width="100px"
                  prop="sqapplyer"
                >
                  <el-input
                    v-model="formData.sqapplyer"
                    placeholder="请输入联系人姓名"
                  ></el-input>
                </el-form-item>
                <el-form-item label="联系方式" label-width="100px" prop="phone">
                  <el-input
                    v-model="formData.phone"
                    placeholder="请输入联系方式"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="content" :label="contentLabel[type]">
                  <el-input
                    ref="content"
                    type="textarea"
                    :placeholder="contentLabelts[type]"
                    :rows="8"
                    v-model="formData.content"
                    name="content"
                    tabindex="1"
                    autocomplete="off"
                    prefix-icon="el-icon-lock"
                    maxlength="300"
                    show-word-limit
                  />
                </el-form-item>
                <el-button
                  :loading="loading"
                  type="primary"
                  class="login-button"
                  @click.native.prevent="submitForm"
                  style="letter-spacing: 20px; text-align: center"
                  >提交
                </el-button>
              </div>
            </el-form>
            <el-form
              ref="formData"
              :model="formData"
              :rules="loginRules"
              autocomplete="on"
              label-position="left"
              v-else-if="type == 2"
            >
              <h2 class="form-title">
                {{ this.headerTitle[this.type] }}
              </h2>
              <div class="input-login">
                <el-form-item
                  label="联系人"
                  label-width="100px"
                  prop="sqapplyer"
                >
                  <el-input
                    v-model="formData.sqapplyer"
                    placeholder="请输入联系人姓名"
                  ></el-input>
                </el-form-item>
                <el-form-item label="联系方式" label-width="100px" prop="phone">
                  <el-input
                    v-model="formData.phone"
                    placeholder="请输入联系方式"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="content" :label="contentLabel[type]">
                  <el-input
                    ref="content"
                    type="textarea"
                    :placeholder="contentLabelts[type]"
                    :rows="8"
                    v-model="formData.content"
                    name="content"
                    tabindex="1"
                    autocomplete="off"
                    prefix-icon="el-icon-lock"
                    maxlength="300"
                    show-word-limit
                  />
                </el-form-item>
                <el-button
                  :loading="loading"
                  type="primary"
                  class="login-button"
                  @click.native.prevent="submitForm"
                  style="letter-spacing: 20px; text-align: center"
                  >提交
                </el-button>
              </div>
            </el-form>
            <el-form
              class="newform"
              ref="formData"
              :model="formData"
              :rules="loginRules"
              autocomplete="on"
              label-position="top"
              v-else-if="type == 3"
            >
              <h2 class="form-title" style="margin-bottom: 1.5rem">
                {{ this.headerTitle[this.type] }}
              </h2>
              <div class="input-login input-login2">
                <!-- <el-form-item label="部门列表" label-width="100px">
                  <el-select
                    v-model="deptform.deptId"
                    placeholder="请选择部门"
                    clearable
                    :style="{ width: '100%' }"
                  >
                    <el-option
                      v-for="(item, index) in deptList"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item> -->
                <el-form-item
                  label-width="100px"
                  class="radiocenter"
                  v-for="(item, index) in deptListdata"
                  :key="index"
                  :label="item.dict_label"
                >
                  <el-radio-group
                    v-model="deptform.scorevalue[index]"
                    @change="radioChange($event, item)"
                  >
                    <el-radio label="好"> 好({{ item.hao }}) </el-radio>
                    <el-radio label="较好"> 较好({{ item.jiaohao }}) </el-radio>
                    <el-radio label="一般"> 一般({{ item.yiban }}) </el-radio>
                    <el-radio label="差"> 差({{ item.cha }}) </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <el-button
                :loading="loading"
                type="primary"
                class="login-button"
                @click.native.prevent="submitdept"
                style="letter-spacing: 20px; text-align: center;margin-top: 15px;height: 50px;"
                >提交
              </el-button>
            </el-form>
            <el-form
              ref="formData"
              :model="deptform"
              :rules="loginRules"
              autocomplete="on"
              label-position="left"
              v-else-if="type == 4"
            >
              <h2 class="form-title" style="margin-bottom: 1.5rem">
                {{ this.headerTitle[this.type] }}
              </h2>
              <div class="input-login">
                <el-form-item
                  label="反馈人"
                  label-width="100px"
                  style="margin-bottom: 1rem"
                >
                  <el-input
                    v-model="deptform.recommender"
                    placeholder="请输入反馈人姓名"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="反馈人电话"
                  label-width="100px"
                  style="margin-bottom: 1rem"
                >
                  <el-input
                    v-model="deptform.recommenderPhone"
                    placeholder="请输入反馈人联系方式"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="content" :label="contentLabel[type]">
                  <el-input
                    ref="content"
                    type="textarea"
                    :placeholder="contentLabelts[type]"
                    :rows="8"
                    v-model="deptform.content"
                    name="content"
                    tabindex="1"
                    autocomplete="off"
                    prefix-icon="el-icon-lock"
                    maxlength="300"
                    show-word-limit
                  />
                </el-form-item>
                <el-button
                  :loading="loading"
                  type="primary"
                  class="login-button"
                  @click.native.prevent="submitfk"
                  style="letter-spacing: 20px; text-align: center"
                  >提交
                </el-button>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import variableStyle from "@/styles/variable.scss";
export default {
  name: "suqiuContentMobile",
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
    }),
  },
  data() {
    var validateType = (rule, value, callback) => {
      if (this.type != 0) {
        if (!value) {
          callback(new Error("服务事项名称不能为空"));
        }
        callback();
      } else {
        callback();
      }
    };
    var validatePhone = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("电话不能为空"));
      } else {
        var telreg = /^(13[0-9]|15[0-9]|17[0-9]|18[0-9]|14[0-9])[0-9]{8}$/;
        if (telreg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确格式的电话号码"));
        }
      }
    };
    return {
      deptListdata: [],
      judgeList: [],
      count: 0,
      header: "xx",
      titleLabel: [
        "政策咨询",
        "解决问题",
        "定制服务",
        "部门好差评",
        "意见建议",
        "举报投诉",
      ],
      headerTitle: [
        "咨询内容",
        "企业诉求",
        "定制服务",
        "部门好差评",
        "意见建议",
        "投诉内容",
      ],
      type: 3, // 诉求类型,用于区分表单展示
      contentLabel: [
        "咨询内容",
        "诉求内容",
        "服务内容",
        "评价内容",
        "建议内容",
        "投诉内容",
      ], // 文本框展示label
      contentLabelts: [
        "请输入您需要咨询的内容（惠企政策、人才政策、政务服务审批流程等）",
        "请输入您的诉求内容（日常生产经营中需要解决的问题）",
        "请输入您的服务内容（政务审批中的代办、上门等定制化服务）",
        "请输入您的评价",
        "请输入您的建议内容（请对企业码的运行和政府的工作作风给予建议）",
        "请输入您的投诉内容",
      ], // 文本框展示label提示
      suqiuValue: "",
      suqiuOptions: [
        { value: "上门服务", label: "上门服务" },
        { value: "大厅帮办", label: "大厅帮办" },
      ],
      variableStyle: variableStyle,
      formData: {},
      loginRules: {
        sqapplyer: [
          { required: true, trigger: "blur", message: "请输入联系人" },
        ],
        phone: [{ validator: validatePhone, required: true, trigger: "blur" }],
        enterpriseName: [
          { required: true, trigger: "blur", message: "请输入企业名称" },
        ],
        content: [{ required: true, trigger: "blur", message: "请输入内容" }],
        sxname: [{ validator: validateType, trigger: "blur" }],
      },
      loading: false,
      deptList: [
        { value: "001003025002026", label: "市场监督管理局" },
        { value: "001003025002056", label: "信阳供电公司" },
        { value: "001003025002052", label: "市供水集团有限公司" },
        { value: "001003025002053", label: "信阳富地燃气有限公司" },
        { value: "001003025002048", label: "市自然资源和规划局" },
        { value: "001003025002019", label: "市税务局" },
        { value: "001003025002043", label: "市发展改革委" },
        { value: "001003025002101", label: "信阳海关" },
        { value: "001003025002102", label: "市中级法院" },
        { value: "001003025002021", label: "市金融工作局" },
        { value: "001003025002103", label: "信阳银保监分局" },
        { value: "001003025002060", label: "人民银行信阳市中心支行" },
        { value: "001003025002015", label: "市人力资源和社会保障局" },
        { value: "001003025002035", label: "市财政局" },
        { value: "001003025002104", label: "市公共资源交易中心" },
        { value: "001003025002051", label: "市科技局" },
        { value: "001003025002037", label: "市商务局" },
        { value: "001003025002025", label: "市生态环境局" },
        { value: "001003025002014", label: "市工业和信息化局" },
        { value: "001003025002012", label: "市交通运输局" },
        { value: "001003025002105", label: "市委政法委" },
      ],
      pjList: [
        { label: "好", value: "4" },
        { label: "较好", value: "3" },
        { label: "一般", value: "2" },
        { label: "差", value: "1" },
      ],
      deptform: {
        scorevalue: [],
      },
    };
  },
  methods: {
    radioChange(val, item) {
      for (let i = 0; i < this.judgeList.length; i++) {
        if (item.dict_label == this.judgeList[i].deptName) {
          this.judgeList[i].score = val;
          return;
        }
      }
      this.judgeList.push({
        deptName: item.dict_label,
        score: val,
        deptId:item.dict_value,

      });
    },
    getDeptJugdeList() {
      let url = "/dev-api/evaluate/countEveryDeptCount";
      this.$httpApi
        .get(url)
        .then((res) => {
          this.deptListdata = res.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    goBack() {
      this.$router.replace({
        path: "/suqiuMobile",
      });
    },
    // 初始化表单
    initData() {
      console.log(this.userInfo);
      this.formData = {
        enterpriseName: this.userInfo.enterpriseInfo.enterprise,
        tyshxydm: this.userInfo.tyshxydm,
        phone: "",
        userid: this.userInfo.userId,
        content: "",
        leadername: "",
        status: 1,
        sqapplyer: "",
        deptid: "",
        deptname: "",
        lbdeptid: "",
        sxname: "",
        sqProblemType: "", // 诉求类型 下拉框选项
        title: this.titleLabel[this.type],
        header: this.headerTitle[this.type],
        leadername: this.userInfo.enterpriseInfo.enterprise,
      };
      this.deptform = {
        tyshxydm: this.userInfo.tyshxydm,
        deptId: "",
        deptName: "",
        score: "",
        scorevalue: [],
        qyName: this.userInfo.enterpriseInfo.enterprise,
        frName: this.userInfo.userName,
        frPhone: this.userInfo.phonenumber,
        recommender: "",
        recommenderPhone: "",
        content: "",
      };
    },
    submitForm() {
      console.log(this.formData);
      this.$refs.formData.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$httpApi
            .post("/dev-api/sq_info/add", this.formData)
            .then((res) => {
              this.loading = false;
              console.log(res);
              if (res.code === 200) {
                this.$message.success(
                  "提交成功！请在右上角用户中心查看办理进度"
                );
                setTimeout(() => {
                  this.$router.replace({
                    path: "/suqiuMobile",
                  });
                }, 1500);
              }
            })
            .catch((err) => {
              this.loading = false;
            });
        }
      });
    },
    submitdept() {
      let that = this;
      this.judgeList.forEach((item) => {
        that.submitdeptFunc(item.deptName, item.score,item.deptId);
      });
    },
    submitdeptFunc(deptName, score,deptId) {
      debugger
      let url = "/dev-api/evaluate/add";
      let params = JSON.parse(JSON.stringify(this.deptform));
      // this.deptList.forEach((element) => {
      //   if (element.value == params.deptId) {
      //     params.deptName = element.label;
      //   }
      // });
      // this.pjList.forEach((item) => {
      //   if (item.value == params.scorevalue) {
      //     params.score = item.label;
      //   }
      // });
      params["deptName"] = deptName;
      params["score"] = score;
      params["deptId"] = deptId;
      this.$httpApi
        .post(url, params)
        .then((r) => {
          this.count++;
          if (this.count == this.judgeList.length) {
            this.count=0;
            this.$message.success("提交成功");
            setTimeout(() => {
              this.$router.replace({
                path: "/suqiuMobile",
              });
            }, 1500);
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    submitfk() {
      let url = "/dev-api/advice/add";
      let params = JSON.parse(JSON.stringify(this.deptform));
      this.$httpApi
        .post(url, params)
        .then((r) => {
          if (r.code === 200) {
            this.$message.success("提交成功");
            setTimeout(() => {
              this.$router.replace({
                path: "/suqiuMobile",
              });
            }, 1500);
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getDeptJugdeList();
    let type = this.$route.query.type;
    this.type = (type > 3 ? type - 3 : type) || 0;
    if (this.type === 0) {
      this.contentLabel = "咨询问题";
    }
    this.initData();
  },
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import "@/styles/com/theme.scss";
.background {
  background-color: white;
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  .header {
    z-index: 100;
    width: 100%;
    height: 40px;
    position: fixed;
    top: 0;
    .header-wrap {
      flex: 1;
      width: 100%;
      height: 100%;
      //background: #FFFFFF;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      .header-img {
        width: 30px;
        height: 30px;
        margin-top: 1rem;
      }
    }
  }
  .img1 {
    width: 100vw;
    height: 100vh;
    // z-index: 101;
    position: absolute;
  }
  .img2 {
    width: 27rem;
    margin-left: -3.5rem;
    height: 471.1px;
    z-index: 101;
    position: absolute;
    top: 75%;
    margin-top: -336.5px;
  }
}
.login-container {
  width: 100%;
  height: 100vh;
  background: url("../../assets/images/login_banner.png") center / 100% 100%
    no-repeat;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  overflow: hidden;
}
.login-system-name {
  position: absolute;
  top: 10vh;
  height: 60px;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
}
.wrap-thumbnail,
.login-content {
  position: absolute;
  top: 45%;
  z-index: 102;
  -webkit-transform: translateY(-30%);
  -moz-transform: translateY(-30%);
  -o-transform: translateY(-30%);
  -ms-transform: translateY(-30%);
  transform: translateY(-30%);
}
.wrap-thumbnail {
  right: 50%;
  height: 400px;
  img {
    height: 100%;
  }
  .thumbnail-content {
    position: absolute;
    top: -20px;
    right: 10%;
    width: max-content;
    color: #ffffff;
    font-weight: bold;
    background-color: #1292ff;
    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      display: block;
      border-top: 5px solid transparent;
      border-right: 8px solid #1292ff;
      border-bottom: 5px solid transparent;
      -webkit-transform: translate(-100%, -50%);
      -moz-transform: translate(-100%, -50%);
      -o-transform: translate(-100%, -50%);
      -ms-transform: translate(-100%, -50%);
      transform: translate(-100%, -50%);
    }
  }
}
// .login-content {
//     left: 50%;
// }
.form-content {
  width: 23.5rem;
  height: 500px;
  padding: 20px;
  /*/ / border: 1 px solid #333;*/
  border-radius: 12px;
  background: #fff;
  box-shadow: 0px 3px 15px rgba($color: rgb(0, 0, 0), $alpha: 0.2);
  position: relative;
  margin-top: 40px;
  // span {
  //   font-size: 16px;
  //   font-weight: 600;
  // }
  .el-form {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    align-items: center;
    .el-form-item {
      width: 100%;
      .el-form-item__content {
        height: 70px;
      }
    }
    .code-box {
      /*/ / background: red;*/
      width: 100%;
      .el-form-item__content {
        width: 100%;
        height: 100%;
        .login-code-ipt {
        }
        .login-code-img {
          width: 100px;
          height: 42px;
          cursor: pointer;
        }
      }
      .login-code-btn {
        margin-left: 4px;
      }
    }
  }
  .newform {
    justify-content: unset;
  }
  .el-btn-ctr,
  .to-login {
    width: 100%;
    padding: 0 40px;
    margin-top: 10px;
  }
  .el-button {
    width: 100%;
  }
  .to-login {
    margin-top: 10px;
    position: relative;
    a {
      position: absolute;
      right: 40px;
    }
  }
  .btn-btm {
    width: 64px;
    height: 21px;
    margin-top: 20px;
    margin-right: 20px;
    font-size: 16px;
    text-align: left;
    a {
      color: #999999;
    }
  }
  .code-login-img {
    position: absolute;
    right: 1px;
    bottom: 1px;
    width: 60px;
    height: 60px;
    .code-img {
      width: 100%;
      height: 100%;
    }
  }
  .code-login {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    // height: 100%;
    text-align: center;
    .qr-code-box {
      width: 200px;
      height: 200px;
      margin-bottom: 20px;
      position: relative;
      .qr-code-img {
        width: 100%;
        height: 100%;
        background: #efefef;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .invalid-mask {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba($color: #fff, $alpha: 0.8);
        color: #000;
        font-size: 15px;
        font-weight: bold;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .shuaxin {
          width: 62px;
          height: 35px;
          line-height: 35px;
          border-radius: 50px;
          background-color: #383d42;
          color: #fff !important;
          margin-top: 16px;
        }
        .tip-img {
          width: 34px;
          height: 34px;
        }
        .tip-success {
          color: #000;
          font-size: 12px;
          margin-top: 24px;
          margin-bottom: 10px;
        }
        .tip-info {
          color: #000;
          font-size: 12px;
          font-weight: 700;
        }
      }
    }
    .tip-top {
      font-size: 14px;
      color: #222;
    }
    .tip-bottom {
      font-size: 12px;
      color: #555;
    }
    .tip-red {
      color: #f00;
    }
  }
}
.form-title {
  width: 100%;
  text-align: center;
  color: $col-theme;
  letter-spacing: 10px;
  margin-bottom: 10px;
}
.input-login {
  width: 100%;
  min-height: 200px;
  .login-button {
    width: 100%;
    height: 50px;
    font-family: Microsoft YaHei;
    color: #ffffff;
    font-size: 16px;
    background-color: $col-theme;
    // margin-top: 30px;
  }
}
.input-login2 {
  height: 340px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  ::v-deep .el-form-item__label {
    padding: 0 !important;
  }
}
.p-content {
  padding: 30 upx;
  .p-cell {
    background-color: #1995fe;
    color: #ffffff;
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 700;
    text-align: left;
    cursor: pointer;
    .p-position {
      font-size: 13px;
    }
  }
}
@media screen and (min-width: 1200px) {
  .wrap-thumbnail {
    right: 55%;
  }
  .login-content {
    left: 28.5%;
    z-index: 102;
  }
}
.linkList {
  width: 115px;
  margin-top: 30px;
  text-align: center;
  div {
    margin: 10px auto;
    color: #e6503b;
  }
}
.el-form-item {
  //margin-bottom: 10px;
}
.imgLink {
  width: 40px;
  height: 40px;
  background-color: red;
  background: url("../../assets/images/henan.png") center / 100% 100% no-repeat;
}
.chooseLogin {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
  font-size: 20px;
  .light {
    color: #1292ff;
  }
}
::v-deep {
  .el-form-item {
    margin-bottom: 20px;
  }
}
.newheight {
  // width: 340px;
  // height: 450px;
}
::v-deep .radiocenter {
  .el-form-item__content {
    // text-align: center;
    border-bottom: 1px solid #ccc;
  }
}
::v-deep .el-radio {
  margin-right: 10px !important;
}
::v-deep .el-radio__label {
  padding-left: 0 !important;
}
</style>
